// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import tagEntity from './entities/tag.json';
import tagMenu from '../pages/tag/menu.json';
import tagFullForm from '../pages/tag/forms/full.json';
import tagContextForm from '../pages/tag/forms/context.json';
import tagMiniForm from '../pages/tag/forms/mini.json';
import tagLookupForm from '../pages/tag/forms/lookup.json';
import tagTableView from '../pages/tag/views/table.json';
import tagStagesView from '../pages/tag/views/stages.json';
import tagCardsView from '../pages/tag/views/cards.json';
import tagInlineView from '../pages/tag/views/inline.json';
import tagBacklogView from '../pages/tag/views/backlog.json';
import tagSplitView from '../pages/tag/views/split.json';
import tagCalendarView from '../pages/tag/views/calendar.json';
import tagDashboardView from '../pages/tag/views/dashboard.json';

/** Тип запису «Тег» зі сторінками пакета: меню, форми та подання з pages/tag/. */
export const tagDefinition: IRecordTypeDefinition = {
  ...tagEntity,
  views: assembleViewSet({
      table: tagTableView,
      stages: tagStagesView,
      cards: tagCardsView,
      inline: tagInlineView,
      backlog: tagBacklogView,
      split: tagSplitView,
      calendar: tagCalendarView,
      dashboard: tagDashboardView,
  }),
  form: tagFullForm,
  forms: { full: tagFullForm, context: tagContextForm, mini: tagMiniForm, lookup: tagLookupForm },
  menu: tagMenu,
} as IRecordTypeDefinition;
